import React, { useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import UploadIMG from "../components/uploads/UploadIMG";
import { useEffect } from 'react';
import { createAndUpdateBusOfficeByID, getBusOffice } from '../api/business_api'
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function MThaiTower() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [txtEnSpecific, setTxtEnSpecific] = useState('');
    const [txtThSpecific, setTxtThSpecific] = useState('');
    const [txtEnFacilities, setTxtEnFacilities] = useState('');
    const [txtThFacilities, setTxtThFacilities] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);

    const [dataContact, setDataContact] = useState({
        toMthai: null,
        ccMthai: null,
        linkVR: null,
    });

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };

    const handleSelectedImages4 = (images) => {
        setImages4(images);
    };
    const handleSelectedRemoveImg4 = (data) => {
        setImages4(data);
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    window.location.reload();
                }
                else { }
    };

    const validateEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
        try {
            const emailFields = [
                { field: 'email_contact', value: dataContact.toMthai },
                { field: 'email_cc', value: dataContact.ccMthai },
            ];
    
            // Validate required email fields
            const invalidEmailFields = emailFields.filter(field => field.value && !validateEmail(field.value));
            
            if (invalidEmailFields.length === 0) {
                const formatedBodyToServer = {
                    type: 'm_thai',
                    content_type: "office_building",
                    content_sub_type: "m_thai",
                    vr_link: dataContact.linkVR,
                    description_en: txtEnDesc,
                    description_th: txtThDesc,
                    specification_en: txtEnSpecific,
                    specification_th: txtThSpecific,
                    facilities_en: txtEnFacilities,
                    facilities_th: txtThFacilities,
                    email_contact: dataContact.toMthai,
                    email_cc: dataContact.ccMthai,
                    spec_img: images1 ?? null,
                    fac_img: images2 ?? null,
                    gallery: images3 ?? null,
                    plan_img: images4 ?? null,
                }
                if (
                    // !formatedBodyToServer.vr_link ||
                    !formatedBodyToServer.description_en ||
                    !formatedBodyToServer.description_th ||
                    !formatedBodyToServer.specification_en ||
                    !formatedBodyToServer.specification_th ||
                    !formatedBodyToServer.facilities_en ||
                    !formatedBodyToServer.facilities_th ||
                    !formatedBodyToServer.spec_img.length > 0 ||
                    !formatedBodyToServer.fac_img.length > 0 ||
                    !formatedBodyToServer.gallery.length > 0 ||
                    !formatedBodyToServer.plan_img.length > 0
                ) {
                    await alertValidate(
                        {
                            title: "Please fill your information completely.",
                            text: "กรุณากรอกข้อมูลให้ครบถ้วน"
                        });
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                          (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateBusOfficeByID('',formatedBodyToServer);
                            setLoading(false)
                            if (response.status == "success"||response.status == 200) {
                                const result = await alertSaved();
                                  if (result.isConfirmed) {
                                    window.location.reload();
                                  }
                              }
                          })();
                        }
                }
            } else {
                alertValidate(
                    {
                        title: "Please fill your information completely.",
                        text: "กรุณากรอกข้อมูลให้ครบถ้วน"
                    });
            }
        } catch (error) {
            console.log('found error ', error)
        }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const param = {
                type: 'm_thai',
            }

            const response = await getBusOffice(param)

            await setDataContact({
                ...dataContact,
                toMthai: response?.data?.data?.email_contact,
                ccMthai: response?.data?.data?.email_cc,
                linkVR: response?.data?.data?.vr_gallery,
            })

            if (response?.data?.data?.description_en) {
                setTxtEnDesc(response?.data?.data?.description_en)
            }
            if (response?.data?.data?.description_th) {
                setTxtThDesc(response?.data?.data?.description_th)
            }

            if (response?.data?.data?.spec_en) {
                setTxtEnSpecific(response?.data?.data?.spec_en)
            }
            if (response?.data?.data?.spec_th) {
                setTxtThSpecific(response?.data?.data?.spec_th)
            }

            if (response?.data?.data?.fac_en) {
                setTxtEnFacilities(response?.data?.data?.fac_en)
            }
            if (response?.data?.data?.fac_th) {
                setTxtThFacilities(response?.data?.data?.fac_th)
            }

            setImagesFromApi1([{
                id: 0,
                status: false,
                src:
                    response?.data?.data?.spec_img === null ||
                    response?.data?.data?.spec_img === ""
                    ? ''
                    : response?.data?.data?.spec_img,
                file: response?.data?.data?.spec_img ? await urlToBlob(response?.data?.data?.spec_img) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi2([{
                id: 0,
                status: false,
                src:
                    response?.data?.data?.fac_img === null ||
                    response?.data?.data?.fac_img === ""
                    ? ''
                    : response?.data?.data?.fac_img,
                file: response?.data?.data?.fac_img ? await urlToBlob(response?.data?.data?.fac_img) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            const gallery = response?.data?.data?.gallery;
            if (gallery && Array.isArray(gallery)) {
                const images = await Promise.all(gallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi3(images);
            }
            const plan_img = response?.data?.data?.plan_img;
            if (plan_img && Array.isArray(plan_img)) {
                const images = await Promise.all(plan_img.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi4(images);
            }
        } catch (error) {
            console.log('error', error);
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])

  return (
    <>
        <style>
            {`
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BUSINESS"} />
        <Menu
            parentmenu={"infoBusiness"}
            activemenu={"infoMThaiTower"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-business.png" className="ic-user01 me-2" alt="" />
                                BUSINESS<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" />  OFFICE BUILDING<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> M THAI TOWER
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    M THAI TOWER <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDesc}
                                    onChange={(newData) => {
                                        setTxtEnDesc(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDesc}
                                    onChange={(newData) => {
                                        setTxtThDesc(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnSpecific}
                                    onChange={(newData) => {
                                        setTxtEnSpecific(newData);
                                    }}
                                    placeholder="Specifications"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThSpecific}
                                    onChange={(newData) => {
                                        setTxtThSpecific(newData);
                                    }}
                                    placeholder="ข้อมูลเพิ่มเติม"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnFacilities}
                                    onChange={(newData) => {
                                        setTxtEnFacilities(newData);
                                    }}
                                    placeholder="Facilities"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThFacilities}
                                    onChange={(newData) => {
                                        setTxtThFacilities(newData);
                                    }}
                                    placeholder="สิ่งอำนวยความสะดวก"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Email Contact
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={1}><span className='fontReg font-size03 colorBlack01'>To.</span></Col>
                                    <Col xs={10} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="to_Mthai"
                                            placeholder="Email Contact"
                                            value={dataContact.toMthai}
                                            onChange={(event) => setDataContact({ ...dataContact, toMthai: event.target.value })}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={1}><span className='fontReg font-size03 colorBlack01'>Cc.</span></Col>
                                    <Col xs={10} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="cc_Mthai"
                                            placeholder="Email Contact"
                                            value={dataContact.ccMthai}
                                            onChange={(event) => setDataContact({ ...dataContact, ccMthai: event.target.value })}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image Specifications <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image Facilities <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 960x460 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                            <Col xs={6}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages2}
                                    images={imagesFromApi2}
                                    txtDetail={"jpg. / 960x460 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg2}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Gallery Album / Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={10}
                                    onSelectedImages={handleSelectedImages3}
                                    images={imagesFromApi3}
                                    txtDetail={"jpg. / 800x400 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg3}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Plan / Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages4}
                                    images={imagesFromApi4}
                                    txtDetail={"jpg. / 800x400 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg4}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    360 Virtual 
                                </font>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={6} className='pe-1'>
                                <input
                                    type="text"
                                    className="inp01 fontLight font-size03"
                                    id="linkVR"
                                    placeholder="Enter Link 360"
                                    value={dataContact.linkVR}
                                    onChange={(event) =>
                                        setDataContact({
                                            ...dataContact,
                                            linkVR: event.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default MThaiTower;